import { forwardRef } from 'react'

import { useProgressiveImage } from './useProgressiveImage'
import styles from './ProgressiveImage.module.scss'

type ProgressiveImageProps = {
  src: string
  alt?: string
  fallbackText?: string
  placeholderSrc?: string
  className?: string
  style?: React.CSSProperties
  onLoad?: () => void
}

const ProgressiveImage = forwardRef<HTMLImageElement, ProgressiveImageProps>(
  (
    {
      src,
      alt = '',
      fallbackText = 'image failed to load',
      placeholderSrc,
      className = '',
      style,
      onLoad,
    },
    ref
  ) => {
    const { isLoading, hasError, loadedSrc } = useProgressiveImage(src)

    return (
      <div className={`${styles.progressiveImageRoot} ${className}`}>
        {isLoading && (
          <span className={styles.loadingText}>Loading {alt}...</span>
        )}

        {hasError && !isLoading && (
          <span className={styles.errorText}>{`${alt} ${fallbackText}`}</span>
        )}

        {!isLoading && !hasError && (
          <img
            ref={ref}
            src={loadedSrc ?? placeholderSrc ?? ''}
            alt={alt}
            className={styles.image}
            style={style}
            onLoad={onLoad}
          />
        )}
      </div>
    )
  }
)

// Optional: for better debugging in React DevTools
ProgressiveImage.displayName = 'ProgressiveImage'

export default ProgressiveImage
